module.exports = __webpack_public_path__ + "static/media/ToDo.3c4d6252.jpg";